export const ductSystemDropdownData = {
  pressureClass: [
    "Positive 2-inch W.G",
    "Positive 3-inch W.G",
    "Positive 4-inch W.G",
    "Positive 6-inch W.G",
    "Positive 10-inch W.G",
    "Negative 2-inch W.G",
    "Negative 3-inch W.G",
    "Negative 4-inch W.G",
    "Negative 6-inch W.G",
    "Negative 10-inch W.G",
    "Welded Black Iron",
    "16 GA Welded Stainless Steel",
    "Aluminum 2-inch W.G",
    "Welded Aluminum",
    "Negative 2-inch W.G - PVC Coated",
    "Negative 3-inch W.G - PVC Coated",
    "Negative 4-inch W.G - PVC Coated",
    "Negative 6-inch W.G - PVC Coated",
    "Negative 10-inch W.G - PVC Coated",
  ],
  sealClass: ["Welded", "A", "B"],
  wrap: [
    "None",
    '1" FSK',
    "1-1/2 FSK",
    '2" FSK',
    '1" Rigid Board',
    '1-1/2" Rigid Board',
    '2" Rigid Board',
    '1" Rigid Board with Aluminum Coating',
    '1-1/2" Rigid Board with Aluminum Coating',
    '2" Rigid Board with Aluminum Coating',
    'Firewrap 1-1/2" (1 Layer)',
    'Firewrap 3" (2 Layers)',
    "Lagging",
  ],
  liner: ["None", '1/2" Liner', '1" Liner', '1-1/2" Liner', '2" Liner'],
};
